module.exports = __webpack_public_path__ + "img/trophy_0000_shield.b4f65e26.png";